import { isEmpty, toUpper } from 'lodash';
import { USER_ID_KEY } from '../global/constants';
import { sessionGetItem } from './storage';
import { getLocalCountryLanguage } from './utils';
import log from './logger';

class DataDogEvent {
  constructor() {
    this.maxLimit = 50;
    this.count = 0;
    this.timer = '';
  }

  getQualtricsSessionId = () => {
    try {
      return window?.QSI?.API?.SessionRecording?.getSessionSync()?.sessionId;
    } catch (e) {
      log.error('Error retrieving Qualtrics session ID:', e);
      return undefined;
    }
  };

  getUserDataForDataDog = () => {
    const userData = sessionGetItem(USER_ID_KEY) || {};
    const { localeCountry = '', localeLanguage = '' } = getLocalCountryLanguage();
    const country = toUpper(localeCountry);
    const language = toUpper(localeLanguage);
    const locale = `${localeLanguage}_${country}`;
    const qualtricsSessionId = this.getQualtricsSessionId();
    if (!isEmpty(userData)) {
      const { userId, firstName, lastName } = userData;
      const id = userId;
      const name = `${firstName} ${lastName}`;
      return { id, name, country, language, locale, qualtrics_session_id: qualtricsSessionId };
    }
    return {
      id: 'Anonymous',
      name: 'Guest',
      country,
      language,
      locale,
      qualtrics_session_id: qualtricsSessionId,
    };
  };

  setUserDataForDataDog = async () => {
    const config = this.getUserDataForDataDog();
    return window?.DD_RUM?.setUser(config);
  };

  callDataDogEvent = async () => {
    if (
      typeof window.DD_RUM !== 'undefined' &&
      typeof this.getQualtricsSessionId() !== 'undefined'
    ) {
      // to check data dog rum and qualtrics script is loaded or not
      await this.setUserDataForDataDog();
      clearTimeout(this.timer);
    } else if (typeof window.DD_RUM !== 'undefined' && this.count > this.maxLimit - 2) {
      // to check if qualtrics script is not loaded but data rum is loaded and run when count will remain 2 less than from maxLimit
      clearTimeout(this.timer);
      await this.setUserDataForDataDog();
    } else if (this.count <= this.maxLimit) {
      this.timer = setTimeout(() => {
        this.count = this.count + 1;
        this.callDataDogEvent().catch(() => clearTimeout(this.timer));
      }, 1000);
    } else {
      clearTimeout(this.timer);
    }
  };

  loadDataDogEvent = async () => {
    await this.callDataDogEvent();
  };
}

const dataDogEvent = new DataDogEvent();

export default dataDogEvent;
